module.exports = __webpack_public_path__ + "static/img/tobigera_moku.a01629c.jpg";